import { IFormatObjectEditable } from "..";
import { IFormatAlert } from "../IFormatAlert";
import { IObjectValidator } from "../IObjectValidator";
import { TextObjectEditor } from "../objectEditors";
import { AbstractFormatObjectAlert, ObjectAlert, RegisterableAlert } from "../alerts";

export class TextObjectValidator implements IObjectValidator {
  public validate(object: IFormatObjectEditable): IFormatAlert[] {
    const alerts: AbstractFormatObjectAlert[] = [];
    if (object instanceof TextObjectEditor) {
      if (object.numberRangeAlertBehavior().isEditable()) {
        const numberRangeAlert = object.numberRangeAlertBehavior().getValue();
        const text = parseFloat(object.text().getValue());
        if (!isNaN(text)) {
          if (numberRangeAlert.lower.isEnable && numberRangeAlert.lower.threshold > text) {
            alerts.push(new RegisterableAlert(object, "下限値が入力値の範囲を超えています。"));
          }
          if (numberRangeAlert.upper.isEnable && numberRangeAlert.upper.threshold < text) {
            alerts.push(new RegisterableAlert(object, "上限値が入力値の範囲を超えています。"));
          }
        }
        if (numberRangeAlert.lower.isEnable && numberRangeAlert.upper.isEnable && numberRangeAlert.lower.threshold > numberRangeAlert.upper.threshold) {
          alerts.push(new ObjectAlert(object, "上限値は下限値以上の値を入力してください。"));
        }
      }
      if (object.lineBreakBehavior().isEditable() && object.fontSizeAutoAdjustBehavior().isEditable()) {
        const fontSizeAutoAdjust = object.fontSizeAutoAdjustBehavior().getValue();
        const lineBreak = object.lineBreakBehavior().getValue();
        if (!fontSizeAutoAdjust.isEnable && lineBreak.isEnable) {
          alerts.push(new ObjectAlert(object, "「禁則処理」を有効にする際は、「文字サイズ自動調節する」も有効にしてください"));
        }
      }
    }
    return alerts;
  }
}
